import type { AddTaskToSelfByTaskTemplateFormValues } from "@/components/Forms/SubForms/AssignTasksToSelfForm.tsx";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useAddCaseTaskToSelfByTaskTemplate = (
    caseUUID?: string,
): UseMutationResult<void, Error, AddTaskToSelfByTaskTemplateFormValues> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (attributes) => {
            const body = {
                ...attributes,
            };

            const response = await fetch(apiUrl("/case-task/add-to-self-by-task"), {
                method: "PUT",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify(body),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["tasks"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["dashboard-tasks-table-data"],
            });

            if (caseUUID) {
                await queryClient.invalidateQueries({
                    queryKey: ["case-tasks", caseUUID],
                });
            }
        },
    });
};
